import {
  Accordion,
  Badge,
  Col,
  FloatingLabel,
  Row,
  Table,
  Modal,
  Form,
  Button,
} from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import forecasts from "../../../assets/data/forecasts.json";
import { AnchorComponent } from "../../../components/elements";
import axios from "axios";
import moment from "moment/moment";

export default function AllFamilyFundForecast() {
  const [show, setShow] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  const [reqs, setReqs] = useState([]);
  const [data, setData] = useState({ thead: [], tbody: [] });

  // filter values use snake_case (from_date / to_date) to match other components/apis
  const [filterValues, setFilterValues] = useState({
    from_date: "",
    to_date: "",
  });

  const [error, setError] = useState("");

  useEffect(() => {
    // local table headers from sample json
    setData(forecasts || { thead: [], tbody: [] });
    // initial fetch (no filters)
    fetchReqs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchReqs = async (params = {}) => {
    try {
      axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/list-forecast",
        { params }
      );
      // defensive: ensure array exists
      setReqs(response?.data?.family_requests || []);
    } catch (err) {
      console.error("Error fetching forecasts list:", err);
      setReqs([]);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFilterValues((prevState) => ({
        ...prevState,
        [name]: files[0],
      }));
    } else {
      setFilterValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    // live-clear error if dates are now valid
    const updated = {
      ...filterValues,
      [name]: type === "file" ? files[0] : value,
    };
    const { from_date, to_date } = updated;
    if (
      (from_date && to_date && new Date(to_date) >= new Date(from_date)) ||
      (!from_date && !to_date)
    ) {
      setError("");
    }
  };

  const handleApplyFilter = async (e) => {
    if (e && e.preventDefault) e.preventDefault();

    const { from_date, to_date } = filterValues;

    // Same validation logic as in your ViewUsetDetails component
    if (!from_date && !to_date) {
      setError("Please enter From Date and To Date.");
      return;
    }
    if (from_date && !to_date) {
      setError("Please select a 'To Date' when 'From Date' is chosen.");
      return;
    }
    if (!from_date && to_date) {
      setError("Please select a 'From Date' when 'To Date' is chosen.");
      return;
    }
    if (from_date && to_date && new Date(to_date) < new Date(from_date)) {
      setError("'To Date' cannot be earlier than 'From Date'.");
      return;
    }

    setError("");
    // call API with params
    await fetchReqs({ from_date, to_date });
  };

  const handleClearFilter = async () => {
    setFilterValues({ from_date: "", to_date: "" });
    setError("");
    await fetchReqs();
  };

  const handleShow = (imageSrc) => {
    setCurrentImage(imageSrc);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setCurrentImage(null);
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{"All Family Fund Forecast"}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    {"home"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link" style={{ color: "#077834" }}>
                    {"Finances"}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{"All Family Fund Forecast"}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>

      {/* FILTER CARD */}
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb" style={{ marginBottom: "10px" }}>
              <h3 className="mc-breadcrumb-title">{"Filter by Date"}</h3>
            </div>

            <Form onSubmit={handleApplyFilter}>
              <Row className="align-items-end">
                <Col md={4}>
                  <Form.Group as={Col}>
                    <FloatingLabel label="From">
                      <Form.Control
                        type="date"
                        name="from_date"
                        value={filterValues.from_date}
                        onChange={handleChange}
                      />
                    </FloatingLabel>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group as={Col}>
                    <FloatingLabel label="To">
                      <Form.Control
                        type="date"
                        name="to_date"
                        value={filterValues.to_date}
                        onChange={handleChange}
                      />
                    </FloatingLabel>
                  </Form.Group>
                </Col>

                <Col md="2">
                  <Button
                    variant="primary"
                    onClick={handleApplyFilter}
                    type="button"
                    style={{
                      paddingTop: "10px",
                      fontWeight: "bold",
                      fontSize: "14px",
                      backgroundColor: "#077834",
                      borderColor: "#077834",
                    }}
                    className="w-100"
                  >
                    Search
                  </Button>
                </Col>

                <Col md="2">
                  <Button
                    variant="secondary"
                    onClick={handleClearFilter}
                    type="button"
                    style={{
                      paddingTop: "10px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                    className="w-100"
                  >
                    Clear Filter
                  </Button>
                </Col>
              </Row>

              {/* Error message shown as small text below date fields */}
              {error && (
                <div className="text-danger mt-2" style={{ fontSize: "13px" }}>
                  {error}
                </div>
              )}
            </Form>
          </div>
        </Col>
      </Row>

      {/* ACCORDION / RESULTS */}
      <Row>
        <div>
          <Accordion defaultActiveKey="0">
            {reqs?.map((req, index) => {
              // Calculate total amount for each req's families
              const totalFamilyAmount = req.families.reduce((sum, item) => {
                const loanAmount = item.person?.loan?.loan_amount || 0;
                const resettlementAmount = item.person?.resettlement_amount || 0;
                const estimatedCost = item.person?.loan?.estimated_business_cost || 0;
                const scholarshipAmount = item.person?.loan?.scholarship_amount || 0;

                return sum + loanAmount + resettlementAmount + estimatedCost + scholarshipAmount;
              }, 0);

              return (
                <Accordion.Item key={index} eventKey={index.toString()} className="custom-accordion">
                  <Accordion.Header>
                    <Table bordered hover size="sm" className="text-center mb-0 head-table table-responsive">
                      <thead className="table-light">
                        <tr>
                          <th>REQ-ID</th>
                          <th>TOTAL FAMILIES</th>
                          <th>TOTAL AMOUNT</th>
                          <th>STATUS</th>
                          <th>DATE REQUESTED</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border rounded">
                          <td>{req.rfq_id}</td>
                          <td>{req.families.length}</td>
                          <td>{totalFamilyAmount}</td>
                          <td>
                            <Badge bg={req.status_id === 5 ? "success" : "warning"}>
                              {req.status?.name}
                            </Badge>
                          </td>
                          <td>{moment(req.created_at).format("DD-MM-YYYY")}</td>
                          <td>
                            <Link to={`/edit-family-fund-forecast/${req.id}`}>
                              <i className="material-icons text-center" title="Edit">edit_note</i>
                            </Link>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div className="mc-table-responsive">
                      <table className="mc-table product">
                        <thead className="mc-table-head primary">
                          <tr>
                            {data?.thead.map((item, idx) => (
                              <th key={idx} style={{ padding: "0.5rem 1rem" }}>
                                {item}
                              </th>
                            ))}
                          </tr>
                        </thead>

                        <tbody className="mc-table-body even">
                          {req.families.map((item, idx) => (
                            <tr key={idx + 1}>
                              <td>{req.rfq_id}</td>
                              <td>{item.person?.f_number}</td>
                              <td>{item.person?.brick_kiln?.brickkiln_name}</td>
                              <td>{item.person?.brick_kiln?.brickkiln_owner}</td>
                              <td>{item.person?.brick_kiln?.brickkiln_owner_cell}</td>
                              <td>{item.person?.brick_kiln?.owner_cnic}</td>
                              <td>{item.person?.identifier?.name}</td>
                              <td>{item.person?.beneficiary_name}</td>
                              <td>{item.person?.cnic}</td>
                              <td>{item.person?.loan?.incentive}</td>
                              <td>
                                {item.person?.loan?.loan_amount}
                                <hr />
                                <i
                                  className="material-icons text-center"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleShow(process.env.REACT_APP_IMG_URL + item.person?.loan?.unpaid_loan_invoice)
                                  }
                                >
                                  receipt_long
                                </i>
                              </td>
                              <td>{item.person?.resettlement_amount}</td>
                              <td>{item.person?.loan?.estimated_business_cost}</td>
                              <td>{item.person?.loan?.scholarship_amount}</td>
                              <td>
                                {item.person?.loan?.loan_amount +
                                  item.person?.resettlement_amount +
                                  item.person?.loan?.estimated_business_cost +
                                  item.person?.loan?.scholarship_amount}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      </Row>

      {/* IMAGE MODAL */}
      <Modal show={show} size="lg" onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Invoice Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentImage ? <img src={currentImage} alt="Invoice" className="img-fluid" /> : <p>No Image Available</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </PageLayout>
  );
}
